import { Model } from '@app/shared/models/model.model';

export class TimeTracking extends Model {
  id: number;
  logs: any;
  minutes: number;
  user_id: number;
}
